export default __webpack_public_path__ + "static/media/image.semba-services.80fc6a1a.png";